import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withUAPLThemedStyles } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import {
  BusinessNameWithAdsLabel,
  Location,
  PlacementFinalUrl,
  PlacementHeadline,
  PlacementAction,
  Rating,
} from '../shared-components';
import { getTextAdPlacementStyles } from '../styles';

import { PlacementCard } from './ad-placement-card';

const TextAdPlacementBase = ({
  customClassName,

  showLongHeadline,
  longHeadline,
  isMultiLineLongHeadline,

  finalUrl,
  showFinalUrl,
  displayUrl,
  isMultiLineFinalUrl,

  showCallToAction,
  callToAction,

  showBusinessNameWithAdsLabel,
  businessName,

  showLocation,
  locationText,

  showRating,
  ratingPoint,
  maxPoint,
  showRatingPoint,
  ratingComment,

  i18n,
  classes,
}) => (
  <PlacementCard
    url={finalUrl}
    mmaPlacementCardClassName={classnames(
      classes.placementCard,
      customClassName
    )}
  >
    <div
      className={classnames(classes.placementTextContainer, 'text-container')}
    >
      {showLongHeadline && (
        <PlacementHeadline
          headlineText={longHeadline}
          isMultiLine={isMultiLineLongHeadline}
          placementHeadlineClassName={classnames(
            classes.placementLongHeadline,
            'long-headline'
          )}
        />
      )}
      {showFinalUrl && (
        <PlacementFinalUrl
          finalUrl={finalUrl}
          displayUrl={displayUrl}
          isMultiLine={isMultiLineFinalUrl}
          placementFinalUrlClassName={classnames(
            classes.placementFinalUrl,
            'final-url'
          )}
        />
      )}
      {showBusinessNameWithAdsLabel && (
        <BusinessNameWithAdsLabel
          showAdsLabel
          businessName={businessName}
          i18n={i18n}
          rootClassName={classnames(
            classes.placementBusinessNameWithAdsLabel,
            'business-name-with-ads'
          )}
        />
      )}
      {showLocation && (
        <Location showDetailLocation locationText={locationText} />
      )}
      {showRating && (
        <Rating
          i18n={i18n}
          ratingPoint={ratingPoint}
          maxPoint={maxPoint}
          showRatingPoint={showRatingPoint}
          commentText={ratingComment}
        />
      )}
      {showCallToAction &&
        callToAction && (
          <PlacementAction
            actionText={callToAction.replace(/([A-Z])/g, ' $1')}
            placementActionClassName={classes.placementCallToAction}
          />
        )}
    </div>
  </PlacementCard>
);

TextAdPlacementBase.propTypes = {
  customClassName: PropTypes.string,

  showLongHeadline: PropTypes.bool,
  longHeadline: PropTypes.string,
  isMultiLineLongHeadline: PropTypes.bool,

  finalUrl: PropTypes.string,
  showFinalUrl: PropTypes.bool,
  displayUrl: PropTypes.string,
  isMultiLineFinalUrl: PropTypes.bool,

  showCallToAction: PropTypes.bool,
  callToAction: PropTypes.string,

  showBusinessNameWithAdsLabel: PropTypes.bool,
  businessName: PropTypes.string,

  showLocation: PropTypes.bool,
  locationText: PropTypes.string,

  showRating: PropTypes.bool,
  ratingPoint: PropTypes.number,
  maxPoint: PropTypes.number,
  showRatingPoint: PropTypes.bool,
  ratingComment: PropTypes.string,

  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    placementCard: PropTypes.string,
    placementTextContainer: PropTypes.string,
    placementLongHeadline: PropTypes.string,
    placementFinalUrl: PropTypes.string,
    placementCallToAction: PropTypes.string,
    placementBusinessNameWithAdsLabel: PropTypes.string,
  }).isRequired,
};

TextAdPlacementBase.defaultProps = {
  customClassName: '',

  showLongHeadline: false,
  showCallToAction: false,
  showFinalUrl: false,
  isMultiLineFinalUrl: false,
  showBusinessNameWithAdsLabel: false,
  showLocation: false,

  showRating: false,
  showRatingPoint: false,

  ratingPoint: 5,
  maxPoint: 5,

  longHeadline: undefined,
  isMultiLineLongHeadline: false,
  finalUrl: undefined,
  displayUrl: undefined,
  callToAction: undefined,
  ratingComment: undefined,
  locationText: undefined,
  businessName: undefined,
};

export const TextAdPlacement = withUAPLThemedStyles(
  props => (
    <TextAdPlacementBase
      {...props}
      showLongHeadline
      showFinalUrl
      showBusinessNameWithAdsLabel
      showLocation
      showRating
      showRatingPoint
      showCallToAction
    />
  ),
  getTextAdPlacementStyles,
  { componentName: 'TextAdPlacement' }
);
